import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const invoiceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInvoices: builder.query({
      query: () => "/invoices",
      providesTags: (result, error, arg) => [{ type: 'Invoice', id: 'LIST' }],
    }),
    getInvoice: builder.query({
      query: ({month, year}) => `invoices/${year}/${month}`,
      providesTags: (result, error, {year, month}) => [{ type: 'Invoice', id: `${year}/${month}` }],
    })
  }),
  overrideExisting: false
})

export const {
  useGetInvoicesQuery,
  useGetInvoiceQuery
} = invoiceApiSlice
